<template>
  <div class="panel-wrapper">
    <div class="panel-wrapper-header">
      <div class="panel-wrapper-header-tabs">
        <widgetTabs :tabs="[
          {
            title: 'Consultants',
            value: 'consultants',
          },
          {
            title: 'Companies',
            value: 'companies',
          },
        ]" @change="onTabChanged"></widgetTabs>

        <div class="row">
          <widgetButton @click="AddTemplate()" class="btn-transparent-secondary outline">
            Add template +
          </widgetButton>
        </div>
      </div>
      <div class="panel-wrapper-header-title-widget">Templates({{ templates.length }})</div>
      <div class="panel-wrapper-header-search-widget">
        <widgetSearch v-model="form_filter.query" :loading="search_loading" class="search-widged" icon="right"
          placeholder="Search here" @keyup="onSearch($event)">
        </widgetSearch>
      </div>
    </div>
    <div class="panel-wrapper-body">
      <div class="panel-wrapper-body-container">
        <QuestionaireTemplateItem v-for="(item, index) in templates" :key="index" :item="item"
          @onTemplateSelected="onTemplateSelected($event, item)" @updateTemplate="updateTemplate"
          @deleteTemplate="deleteTemplate" :class="{ active: selectedItem && selectedItem.id == item.id }">
        </QuestionaireTemplateItem>
      </div>
    </div>

    <!-- Email template preview -->
    <widgetModal v-if="showPreview && selectedItem" :title="selectedItem.title" subtitle="" btnlefttext="Use Template"
      btncentertext="Cancel" btnrighttext="" :leftloading="false" :rightloading="false" :centerloading="false"
      :footerhidden="false" footer_padding="20px 20px" header_padding="20px 20px" body_padding="0px 20px" width="580px"
      @onLeftClick="useTemplate()" @onCenterClick="onCancelUseTemplate">
      <div class="widget-modal-body">
        <div class="template-preview-widget">
          <div class="template-content" v-html="selectedItem.description"></div>
          <Questionaire v-if="selectedItem" :value="selectedItem.questions"></Questionaire>
        </div>
      </div>
    </widgetModal>




  </div>
</template>
  
<script>
import { eventBus } from "@/main";
import QuestionaireTemplateItem from "@/views/Communications/Questionnaire/components/QuestionaireTemplateItem.vue";
import Questionaire from "@/views/Instructor/components/widgets/showQuestionaire.vue";
export default {
  name: "",
  components: {
    QuestionaireTemplateItem,
    Questionaire
  },
  props: {
    phase: {
      type: String,
      default: "",
    },
  },
  data: () => {
    return {
      selectedItem: null,
      showPreview: false,
      loading_page_data: false,
      search_loading: false,
      templates: [],
      form_filter: {
        query: "",
        phase: "",
        type: "consultants",
      }
    };
  },
  mounted() {
    let vm = this;
    eventBus.$on("QuestinaireRefleshTemplate", () => {
      vm.getQuestinaireTemplates();
    });
    vm.getQuestinaireTemplates();
  },
  computed: {},
  watch: {},
  methods: {
    onCancelUseTemplate() {
      let vm = this;
      vm.selectedItem = null;
      vm.showPreview = false;
    },
    onSearch({ target }) {
      let vm = this;
      vm.form_filter.query = target.value;
      vm.getQuestinaireTemplates();
    },
    onTabChanged(tab) {
      let vm = this;
      vm.form_filter.type = tab.value;
      vm.getQuestinaireTemplates();
    },
    getQuestinaireTemplates() {
      let vm = this;
      if (vm.form_filter.query) {
        vm.search_loading = true;
      }
      vm.loading_page_data = true;
      vm.form_filter.phase = vm.phase;
      vm.$store
        .dispatch("COMMUNICATION_QUESTIONAIRE_GET_TEMPLATES", vm.form_filter)
        .then((response) => {
          vm.search_loading = false;
          vm.loading_page_data = false;
          vm.templates = response.data;
        })
        .catch((error) => {
          vm.search_loading = false;
          vm.loading_page_data = false;
        });
    },
    deleteTemplate({ id }) {
      let vm = this;
      vm.$store.dispatch("COMMUNICATION_QUESTIONAIRE_DELETE_TEMPLATE", { id }).then((response) => {
        vm.showPreview = false;
        vm.getQuestinaireTemplates();
        vm.$notify({
          type: "success",
          title: "Success",
          text: "Template deleted successfully",
        });
      }).catch((error) => {
        vm.search_loading = false;
        vm.loading_page_data = false;
      });
    },
    onTemplateSelected(e, item) {
      let vm = this;
      vm.selectedItem = item;
      vm.showPreview = true;
      setTimeout(() => {
        // Get item location on screen
        let el = e.target;
        let itemRect = el.getBoundingClientRect();
        let itemTop = itemRect.top;
        let itemLeft = itemRect.left;
        let itemWidth = itemRect.width;
        let itemHeight = itemRect.height;
        vm.$refs.templatePreview.style.left = itemLeft + itemWidth + "px";
        let templatePreviewRect = vm.$refs.templatePreview.getBoundingClientRect();
        // Position template preview on top if item is on bottom
        let windowheight = window.innerHeight;
        if (windowheight < itemTop + itemHeight + 200) {
          vm.$refs.templatePreview.style.bottom = windowheight - itemTop + "px";
          vm.$refs.templatePreview.style.top = "unset";
        }
        else {
          // check if template preview is out of screen
          if (windowheight + 100 < itemTop + templatePreviewRect.height) {
            vm.$refs.templatePreview.style.top = windowheight - templatePreviewRect.height + "px";
            vm.$refs.templatePreview.style.bottom = "unset";
          }
          else {
            vm.$refs.templatePreview.style.top = itemTop + "px";
            vm.$refs.templatePreview.style.bottom = "unset";
          }

        }
      }, 100);
    },
    useTemplate() {
      let vm = this;
      vm.$emit("onUseTemplate", vm.selectedItem);
      vm.showPreview = false;
    },
    updateTemplate(item) {
      let vm = this;
      vm.$emit("onUpdateTemplate", item);
    },
    AddTemplate() {
      let vm = this;
      vm.$emit("onAddTemplate");
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";

.panel-wrapper {
  width: 338px;
  margin-right: 5px;
  height: 100%;

  .panel-wrapper-header {
    height: 110px;
    background: #ffffff;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;

    .panel-wrapper-header-tabs {
      height: 60px;
      display: flex;
      align-items: center;
      padding: 0px 5px;
    }

    .panel-wrapper-header-title-widget {
      height: 15px;
      display: flex;
      align-items: center;
      padding: 0px 5px;
      font-family: "Nunito";
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      color: #707070;
    }

    .panel-wrapper-header-search-widget {
      height: 40px;
      display: flex;
      align-items: center;
      padding: 0px 5px;

      .search-widged {
        width: 100%;
      }
    }
  }

  .panel-wrapper-body {
    height: calc(100% - 110px);
    overflow-y: auto;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;

    .panel-wrapper-body-container {
      background: #ffffff;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      padding-bottom: 10px;
      display: flex;
      flex-direction: column;
      width: 100%;
    }
  }

  .template-preview-widget {

    .template-title {
      font-family: 'Nunito';
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      color: #1C1C1C;
    }

    .template-content {
      font-family: 'Nunito';
      font-style: normal;
      font-weight: 400;
      font-size: 13px;
      color: #8E8B8B;
      margin-bottom: 20px;
      overflow-y: auto;
    }
  }

}
</style>

  